export default "__VITE_ASSET__DBIltvp$__"